__turbopack_context__.v({
  "button": "Hero2-module__3jET2q__button",
  "content": "Hero2-module__3jET2q__content",
  "link": "Hero2-module__3jET2q__link",
  "root": "Hero2-module__3jET2q__root",
  "side": "Hero2-module__3jET2q__side",
  "text": "Hero2-module__3jET2q__text",
  "title": "Hero2-module__3jET2q__title",
});
